<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='规范科室管理' url='/standardsection/standardsectionlist'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <ZPGLSearchDictItemSelect v-model='condition.spid' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">规范：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.standardid" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in standardOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <AddButton url="/standardsection/standardsectionadd" buttonname="新增"></AddButton>
          <ImportButton url="/standardsection/standardsectionimport" buttonname="导入"></ImportButton>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column>
              <template slot="header">
                专业<br>规范
              </template>
              <template slot-scope="scope">
                {{scope.row.SpName}}<br>{{scope.row.StandardName}}
              </template>
            </el-table-column>
            <el-table-column prop="SecName" label="标准科室">
            </el-table-column>
            <el-table-column label="轮转时间">
              <template slot-scope="scope">
                {{scope.row.SSTime}}月
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
                <el-button @click="Delete(scope.row)" type="text" size="medium" style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StandardSectionList',
    data() {
      return {
        condition: {
          spid: '',
          standardid: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        standardOptions: [],
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APIStandardSection/List',
        loading: true
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Edit: function(row) {
        this.$router.push({
          name: 'StandardSectionEdit',
          params: {
            id: row.SSID
          }
        })
      },
      Delete: function(row) {
        var args = {
          id: row.SSID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.zpgl + '/api/APIStandardSection/Delete', args, row.StandardName, this.$refs.btnSearch.Search)
      },
      LoadStandard: function() {
        var args = {
          token: this.condition.token,
          pageSize: 99999,
          currentPage: 1
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStandard/List', args, function(data) {
          for (var i = 0; i < data.Data.length; i++) {
            var arg = {
              value: data.Data[i]["StandardID"],
              label: data.Data[i]["StandardName"]
            }
            that.standardOptions.push(arg)
          }
        }, null, null, null)
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.LoadStandard()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
